<template>
  <div>
    <v-row>
      <v-col>
        <v-btn
          depressed
          block
          min-height="46"
          color="primary"
          class="white--text text-capitalize rounded-md"
          @click="navigateToCourseCreatePage"
        >
          <v-icon class="pe-2">mdi-plus</v-icon>

          {{ $t("course.createNewCourse") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    navigateToCourseCreatePage() {
      this.$router.push({
        name: "CourseDetails",
      });
    },
  },
};
</script>
